import isEmpty from 'lodash-es/isEmpty';

import { IMAGE_STATUS } from '@ecp/common/src/const/imageFile';

export const formValidators = {
  pcImageFileList: [
    {
      when: ['always'],
      message: '이미지를 모두 등록해주세요.',
      validator: ({ pcImageFileList, pcLogoBasicUseYn }) =>
        !(
          pcLogoBasicUseYn === 'N' &&
          pcImageFileList.filter(({ status }) => status !== IMAGE_STATUS.NEED_TO_DEL).length < 2
        ),
    },
  ],
  loginImageFileList: [
    {
      when: ['always'],
      message: '이미지와 문구를 모두 등록해주세요.',
      validator: ({ loginImageFileList, pcLoginBasicUseYn }) =>
        !(
          pcLoginBasicUseYn === 'N' &&
          loginImageFileList.filter(({ status }) => status !== IMAGE_STATUS.NEED_TO_DEL).length <= 0
        ),
    },
  ],
  loginPhrase: [
    {
      when: ['always'],
      message: '이미지와 문구를 모두 등록해주세요.',
      validator: ({ loginPhrase }) => !isEmpty(loginPhrase),
    },
  ],
  bulkImageFileList: [
    {
      when: ['always'],
      message: '이미지와 문구를 모두 등록해주세요.',
      validator: ({ bulkImageFileList, pcBulkpBasicUseYn }) =>
        !(
          pcBulkpBasicUseYn === 'N' &&
          bulkImageFileList.filter(({ status }) => status !== IMAGE_STATUS.NEED_TO_DEL).length <= 0
        ),
    },
  ],
  bulkPhrase: [
    {
      when: ['always'],
      message: '이미지와 문구를 모두 등록해주세요.',
      validator: ({ bulkPhrase }) => !isEmpty(bulkPhrase),
    },
  ],
  promoImageFileList: [
    {
      when: ['always'],
      message: '이미지를 모두 등록해주세요.',
      validator: ({ promoImageFileList, pcPromoBasicUseYn }) =>
        !(
          pcPromoBasicUseYn === 'N' &&
          promoImageFileList.filter(({ status }) => status !== IMAGE_STATUS.NEED_TO_DEL).length <= 0
        ),
    },
  ],
  ficoImageFileList: [
    {
      when: ['always'],
      message: '이미지를 모두 등록해주세요.',
      validator: ({ ficoImageFileList, pcFicoBasicUseYn }) =>
        !(
          pcFicoBasicUseYn === 'N' &&
          ficoImageFileList.filter(({ status }) => status !== IMAGE_STATUS.NEED_TO_DEL).length <= 0
        ),
    },
  ],
};

export const typeOptions = [
  { value: 'Y', label: '기본형' },
  { value: 'N', label: '직접입력' },
];

export const pcImageItemList = (basic = 'N') => [
  { desc: basic === 'Y' ? 'GNB' : 'GNB\n(145*30)', key: 'pcGnbImgFileId', width: 400, height: 400 },
  {
    desc: basic === 'Y' ? 'Footer' : 'Footer\n(80*57)',
    key: 'pcFooterImgFileId',
    width: 400,
    height: 400,
  },
];

export const loginLogoImageItemList = (basic = 'N') => [
  {
    desc: basic === 'Y' ? 'LOGO' : 'LOGO\n(216*45)',
    key: 'pcLoginImgFileId',
    width: 400,
    height: 400,
  },
];

export const bulkLogoImageItemList = (basic = 'N') => [
  {
    desc: basic === 'Y' ? 'LOGO' : 'LOGO\n(290*60)',
    key: 'pcBulkpImgFileId',
    width: 400,
    height: 400,
  },
];

export const bannerImageItemList = (basic = 'N') => [
  {
    desc: basic === 'Y' ? '이미지' : '이미지\n(580*410)',
    key: 'pcPromoBannerImgFileId',
    width: 400,
    height: 400,
  },
];

export const ficoImageItemList = (basic = 'N') => [
  {
    desc: basic === 'Y' ? 'Favicon' : 'Favicon\n(16*16)',
    key: 'pcFicoImgFileId',
    width: 16,
    height: 16,
  },
];

export const initialForm = {
  pcLogoBasicUseYn: 'Y',
  pcImageFileList: [],
  pcLoginBasicUseYn: 'Y',
  loginImageFileList: [],
  loginPhrase: '',
  pcBulkpBasicUseYn: 'Y',
  bulkImageFileList: [],
  bulkPhrase: '',
  pcPromoBasicUseYn: 'Y',
  promoImageFileList: [],
  pcFicoBasicUseYn: 'Y',
  ficoImageFileList: [],
};

export const initialError = {
  pcImageFileList: '',
  loginImageFileList: '',
  loginPhrase: '',
  bulkImageFileList: '',
  bulkPhrase: '',
  promoImageFileList: '',
};
